// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xy4B","content":"styles_content__1hB4o","tableWrap":"styles_tableWrap__FKQe9"};